import { Provider } from "@redotech/redo-model/order";
import { ShopifyGraphQLProductSchema } from "@redotech/redo-model/product";
import * as z from "zod/v4";

export const getProduct = {
  name: "getProduct" as const,
  input: z.object({ productId: z.string(), provider: z.enum(Provider) }),
  output: z.object({ product: ShopifyGraphQLProductSchema.nullable() }),
};
